import { usePendingApprovals } from '../hooks/usePendingApprovals';
import { ApprovalCard } from '../components/ApprovalCard';

export function ApprovalsPage() {
  const { data, isLoading } = usePendingApprovals();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">Approvals</h2>

      {isLoading && <div className="text-center py-8 text-gray-500">Loading approvals...</div>}

      {data?.approvals && data.approvals.length === 0 && (
        <div className="card p-6 text-center text-gray-500">No pending approvals. All clear!</div>
      )}

      {data?.approvals && (
        <div className="space-y-3">
          {data.approvals.map((approval) => (
            <ApprovalCard key={approval.id} approval={approval} />
          ))}
        </div>
      )}
    </div>
  );
}
